import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import LinkWithSpinnerUI from '../../../widgets/action/LinkWithSpinnerUI'
import CreditMemoChatPanel from './CreditMemoChatPanel'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import './LoanDetail.css'

const LoanFileDownloadUI = ({
    context, loan, account,
    onDownloadCCDoc, downloadCCDocRequested, ccErrorList,
    onDownloadSNDoc, downloadSNDocRequested, snErrorList,
    onDownloadSMItr, downloadSMItrRequested,
    onDownloadDisbursementLetter, disbLetterSubmitted,
    onDownloadLoanStatement, onDownloadLoanStatementRequested,
    onDownloadComfortLetter, onDownloadComfortLetterRequested,
    onDownloadRetailAgreement, downloadRetailAgreementRequested,
    onGenerateCreditMemo, generateCreditMemoRequested,
    onRefreshCreditMemos, refreshCreditMemosRequested,
    creditMemoList, selectedCreditMemo, onCreditMemoSelect, onStartChat,
    showChatIframe, onCloseChatIframe,
    onDownloadCreditMemoPdf, downloadCreditMemoPdfRequested,
    showCreditMemoConfirmModal, onConfirmGenerateCreditMemo, onCancelGenerateCreditMemo,
    showCreditMemoResultModal, creditMemoResultMessage, creditMemoResultType, onCloseCreditMemoResultModal
}) => {
    const isRetailLoan = loan.type === 'retail';
    // Child loans don't have their own disbursement letter; the consolidated letter is on the parent
    const isChildLoan = !!loan.parentLoanId;
    const parentLoanPath = `/su/loans/${loan.parentLoanId}`;

    // Get selected memo details for modal
    const selectedMemo = creditMemoList.find(memo => memo.createdAt === selectedCreditMemo);

    return (
        <CardUI className='g_m_top_100'>
            {
                (['term_sheet', 'sanctioned', 'disbursed'].includes(loan.status) ||
                    loan.status === 'requested' && !['draft', 'appl_fee_paid'].includes(loan.subStatus) ||
                    loan.subStatus === 'repaid' || loan.subStatus == 'prepaid'
                ) &&
                <div className='g_flex_h g_m_top_25 g_flex_left g_flex_top'>
                    <span className='g_flex_h'>
                        <Link className='g_m_right_25' onClick={onDownloadCCDoc} to='#'>
                            Download Credit Committee Document
                        </Link>
                        <SpinnerUI show={downloadCCDocRequested} />
                        <span className='g_m_left_50'>
                            {
                                ccErrorList && ccErrorList.length && ccErrorList[0].message ?
                                    ccErrorList[0].message : ''
                            }
                        </span>
                    </span>
                </div>
            }
            {
                (['term_sheet', 'sanctioned', 'disbursed'].includes(loan.status) ||
                    loan.status === 'requested' && !['draft', 'appl_fee_paid'].includes(loan.subStatus) ||
                    loan.subStatus === 'repaid' || loan.subStatus == 'prepaid'
                ) &&
                <div className='g_flex_h g_m_top_25 g_flex_left g_flex_top'>
                    <span className='g_flex_h'>
                        <Link className='g_m_right_25' onClick={onDownloadSNDoc} to='#'>
                            Download Structure Memo MCA
                        </Link>
                        <SpinnerUI show={downloadSNDocRequested} />
                        <span className='g_m_left_50'>
                            {
                                snErrorList && snErrorList.length && snErrorList[0].message ?
                                    snErrorList[0].message : ''
                            }
                        </span>
                    </span>
                </div>
            }
            {
                (['term_sheet', 'sanctioned', 'disbursed'].includes(loan.status) ||
                    loan.status === 'requested' && !['draft', 'appl_fee_paid'].includes(loan.subStatus) ||
                    loan.subStatus === 'repaid' || loan.subStatus == 'prepaid'
                ) &&
                <div className='g_flex_h g_m_top_25 g_flex_left g_flex_top'>
                    <LinkWithSpinnerUI label='Download Structure Memo ITR' spinnerOnLeft={false}
                        onClick={onDownloadSMItr} busy={downloadSMItrRequested}
                    />
                </div>
            }
            {
                // (loan.status === 'sanctioned' && !['sanction_review', 'sanctioned'].includes(loan.subStatus) ||
                (loan.status === 'disbursed' || loan.subStatus === 'repaid' || loan.subStatus == 'prepaid') &&
                <div className='g_flex_h g_m_top_25 g_flex_left g_flex_top'>
                    {
                        isChildLoan ? (
                            <a
                                className='g_m_right_25'
                                href={parentLoanPath}
                                title={`Redirecting to parent loan ${loan.parentLRN}${loan.parentLoanName ? ` (${loan.parentLoanName})` : ''} for consolidated letter download`}
                            >
                                Download Disbursement Letter
                            </a>
                        ) : (
                            <>
                                <Link className='g_m_right_25' onClick={onDownloadDisbursementLetter} to='#'>
                                    Download Disbursement Letter
                                </Link>
                                <SpinnerUI show={disbLetterSubmitted} />
                            </>
                        )
                    }
                </div>
            }
            {
                (loan.status === 'disbursed' || loan.subStatus === 'repaid' || loan.subStatus == 'prepaid') &&
                <div className='g_flex_h g_m_top_25 g_flex_left  '>
                    <LinkWithSpinnerUI
                        label='Download Loan Statement'
                        onClick={onDownloadLoanStatement}
                        busy={onDownloadLoanStatementRequested}
                    />
                </div>
            }
            {
                isRetailLoan &&
                <div className='g_flex_h g_m_top_25 g_flex_left  '>
                    <LinkWithSpinnerUI
                        label='Download Comfort Letter'
                        onClick={onDownloadComfortLetter}
                        busy={onDownloadComfortLetterRequested}
                    />
                </div>
            }
            {
                account && account.accountType === 'individual' && (loan.status === 'term_sheet' || loan.status === 'sanctioned' || loan.status === 'disbursed' || loan.subStatus === 'repaid' || loan.subStatus == 'prepaid') && isRetailLoan &&
                <div className='g_flex_h g_m_top_25 g_flex_left  '>
                    <LinkWithSpinnerUI
                        label='Download Retail Agreement'
                        onClick={onDownloadRetailAgreement}
                        busy={downloadRetailAgreementRequested}
                    />
                </div>
            }

            {/* Visual Separator */}
            {
                account && account.cinNumber &&
                <div style={{
                    margin: '40px 0 30px 0',
                    borderTop: '2px solid #e0e0e0'
                }} />
            }

            {/* AI Credit Memo Section */}
            {
                account && account.cinNumber &&
                <div style={{
                    padding: '20px',
                    backgroundColor: '#f9f9f9',
                    borderRadius: '5px',
                    border: '1px solid #e0e0e0'
                }}>
                    <div style={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                        marginBottom: '15px',
                        borderBottom: '1px solid #e0e0e0',
                        paddingBottom: '8px',
                        color: '#333'
                    }}>
                        Credit Memo
                    </div>

                    <button
                        onClick={onGenerateCreditMemo}
                        disabled={generateCreditMemoRequested}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: generateCreditMemoRequested ? '#ccc' : '#03a',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: generateCreditMemoRequested ? 'not-allowed' : 'pointer',
                            fontSize: '14px',
                            fontWeight: '500'
                        }}
                    >
                        {generateCreditMemoRequested ? 'Generating...' : 'Generate Credit Memo'}
                    </button>

                    {creditMemoList && creditMemoList.length > 0 && (
                        <div style={{ marginTop: '20px' }}>
                            <div className='g_flex_h' style={{ alignItems: 'center', marginBottom: '8px', gap: '15px' }}>
                                <label style={{
                                    fontWeight: 'bold',
                                    color: '#333',
                                    margin: 0
                                }}>
                                    Select Credit Memo:
                                </label>
                                <LinkWithSpinnerUI
                                    label='Refresh'
                                    onClick={onRefreshCreditMemos}
                                    busy={refreshCreditMemosRequested}
                                    spinnerOnLeft={false}
                                />
                            </div>
                            <select
                                value={selectedCreditMemo || ''}
                                onChange={(e) => onCreditMemoSelect(e.target.value)}
                                style={{
                                    padding: '8px 12px',
                                    borderRadius: '4px',
                                    border: '1px solid #e0e0e0',
                                    fontSize: '14px',
                                    width: '100%',
                                    marginBottom: '12px',
                                    backgroundColor: '#fff',
                                    color: '#333'
                                }}
                            >
                                <option value=''>-- Select a memo --</option>
                                {creditMemoList.map((memo) => {
                                    // Handle both formats:
                                    // Old: CompanyName__dd-MMM-yyyy_HH-mm-ss
                                    // New: yyyy-MM-dd_HH-mm-ss
                                    const formatTimestamp = (timestamp) => {
                                        try {
                                            // Remove company name prefix if present (old format)
                                            let cleanTimestamp = timestamp;
                                            if (timestamp.includes('__')) {
                                                const parts = timestamp.split('__');
                                                cleanTimestamp = parts.length > 1 ? parts[1] : parts[0];
                                            }

                                            const [datePart, timePart] = cleanTimestamp.split('_');
                                            if (!datePart || !timePart) return timestamp;

                                            // Check if it's new format (yyyy-MM-dd) or old format (dd-MMM-yyyy)
                                            const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                                                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

                                            let displayDate;
                                            if (datePart.match(/^\d{4}-\d{2}-\d{2}$/)) {
                                                // New format: yyyy-MM-dd
                                                const [year, month, day] = datePart.split('-');
                                                const monthName = monthNames[parseInt(month, 10) - 1];
                                                displayDate = `${day} ${monthName} ${year}`;
                                            } else {
                                                // Old format: dd-MMM-yyyy
                                                displayDate = datePart;
                                            }

                                            // Parse time: HH-mm-ss -> HH:mm:ss
                                            const formattedTime = timePart.replace(/-/g, ':');

                                            return `${displayDate}, ${formattedTime}`;
                                        } catch (e) {
                                            return timestamp; // Fallback to original if parsing fails
                                        }
                                    };

                                    return (
                                        <option key={memo.createdAt} value={memo.createdAt}>
                                            {formatTimestamp(memo.createdAt)}
                                        </option>
                                    );
                                })}
                            </select>

                            {selectedCreditMemo && (
                                <div style={{
                                    display: 'flex',
                                    gap: '10px',
                                    marginTop: '12px'
                                }}>
                                    <button
                                        onClick={onStartChat}
                                        style={{
                                            flex: 1,
                                            padding: '10px 20px',
                                            backgroundColor: '#388e3c',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            fontSize: '14px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        🔍 Chat with Credit Lens
                                    </button>

                                    <button
                                        onClick={() => onDownloadCreditMemoPdf(
                                            selectedMemo.cin,
                                            selectedMemo.createdAt
                                        )}
                                        disabled={downloadCreditMemoPdfRequested}
                                        style={{
                                            flex: 1,
                                            padding: '10px 20px',
                                            backgroundColor: downloadCreditMemoPdfRequested ? '#ccc' : '#1976d2',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: downloadCreditMemoPdfRequested ? 'not-allowed' : 'pointer',
                                            fontSize: '14px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        {downloadCreditMemoPdfRequested ? 'Downloading...' : '📄 Download PDF'}
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            }

            {/* Credit Memo Chat Side Panel */}
            {showChatIframe && selectedMemo && (
                (() => {
                    return (
                        <CreditMemoChatPanel
                            isOpen={showChatIframe}
                            onClose={onCloseChatIframe}
                            cin={selectedMemo.cin}
                            createdAt={selectedMemo.createdAt}
                            companyName={(account && account.companyName) || 'Credit Memo'}
                            username={context.session.userName}
                            token={context.session.sessionId}
                        />
                    );
                })()
            )}

            {/* Credit Memo Generation Confirmation Modal */}
            <ModalFormUI
                context={context}
                titleLabel='Confirm Credit Memo Generation'
                buttonLabel='Generate'
                cancelLabel='Cancel'
                isOpen={showCreditMemoConfirmModal}
                onRequestClose={onCancelGenerateCreditMemo}
                onSubmit={onConfirmGenerateCreditMemo}
                busy={false}
            >
                <div style={{ padding: '20px', textAlign: 'center' }}>
                    <p style={{ fontSize: '14px', lineHeight: '1.6', color: '#333' }}>
                        Are you sure you want to generate a new Credit Memo?
                    </p>
                    <p style={{ fontSize: '12px', color: '#666', marginTop: '10px' }}>
                        Generation will start in the background and may take up to 10 minutes.
                        You can continue working and check back later for the completed memo.
                    </p>
                </div>
            </ModalFormUI>

            {/* Credit Memo Result Modal */}
            <ModalFormUI
                context={context}
                titleLabel={creditMemoResultType === 'success' ? 'Success' : 'Error'}
                buttonLabel='OK'
                cancelLabel={null}
                isOpen={showCreditMemoResultModal}
                onRequestClose={onCloseCreditMemoResultModal}
                onSubmit={onCloseCreditMemoResultModal}
                busy={false}
            >
                <div style={{ padding: '20px', textAlign: 'center' }}>
                    <p style={{
                        fontSize: '14px',
                        lineHeight: '1.6',
                        color: creditMemoResultType === 'success' ? '#388e3c' : '#d32f2f'
                    }}>
                        {creditMemoResultMessage}
                    </p>
                </div>
            </ModalFormUI>
        </CardUI>
    )
}

export default LoanFileDownloadUI
